<div class="config-container">
    <!-- Sub-tab navigation -->
    <div class="sub-tabs">
        <div
            *ngFor="let section of sections"
            class="sub-tab"
            [class.active]="selectedSection === section"
            (click)="setSection(section)"
        >
            {{ 'permit.config.sections.' + section | translate }}
        </div>
    </div>

    <!-- Content area -->
    <div class="config-content">
        <!-- Header with back/create buttons -->
        <app-permit-settings-header
            [title]="headerTitle"
            [showBackButton]="isFormMode"
            [showCreateButton]="showCreateButton"
            [createButtonTranslationKey]="getCreateButtonTranslationKey()"
            [showSyncButton]="showSyncButton"
            [syncButtonTranslationKey]="syncButtonTranslationKey"
            (back)="onHeaderBack()"
            (create)="onHeaderCreate()"
            (sync)="onHeaderSync()"
        >
        </app-permit-settings-header>

        <!-- List views (when not creating/editing) -->
        <ng-container *ngIf="!isFormMode; else formContent">
            <div class="tab-content" [ngSwitch]="selectedSection">
                <app-permit-config-categories
                    *ngSwitchCase="'categories'"
                    (create)="onCategoryCreate()"
                    (edit)="onCategoryEdit($event)"
                    (editType)="onEditType($event)"
                    (addType)="onAddType($event)"
                ></app-permit-config-categories>
                <app-permit-config-statuses
                    *ngSwitchCase="'statuses'"
                    (create)="onHeaderCreate()"
                    (edit)="onStatusEdit($event)"
                ></app-permit-config-statuses>
                <app-permit-config-departments
                    *ngSwitchCase="'departments'"
                    (edit)="onDepartmentEdit($event)"
                ></app-permit-config-departments>
                <app-permit-config-tags *ngSwitchCase="'tags'"></app-permit-config-tags>
            </div>
        </ng-container>

        <!-- Form views (when creating/editing) -->
        <ng-template #formContent>
            <app-permit-category-form
                *ngIf="isCreatingCategory || isEditingCategory"
                [categoryToEdit]="selectedCategory"
                (saved)="onCategorySaved()"
                (cancel)="onHeaderBack()"
            ></app-permit-category-form>
            <app-permit-status-form
                *ngIf="isCreatingStatus || isEditingStatus"
                [statusToEdit]="selectedStatus"
                (saved)="onStatusSaved()"
                (cancel)="onHeaderBack()"
            ></app-permit-status-form>
            <app-permit-department-form
                *ngIf="isCreatingDepartment || isEditingDepartment"
                [departmentToEdit]="selectedDepartment"
                [nextOrder]="departmentNextOrder"
                (saved)="onDepartmentSaved()"
                (cancel)="onHeaderBack()"
            ></app-permit-department-form>
            <app-permit-type-editor
                *ngIf="isEditingType"
                [categoryId]="typeEditorCategoryId"
                [typeId]="typeEditorTypeId"
                (saved)="onTypeSaved()"
                (cancel)="onTypeCancel()"
            ></app-permit-type-editor>
        </ng-template>
    </div>
</div>
